module.exports = __webpack_public_path__ + "media/images/icons/SVG/026-4c56b14fdbb04248a286a262caf890f1.svg";